import Seo from "../components/modules/Seo";
import Hero from "../components/modules/Hero";
import WhyChooseUs from "../components/modules/WhyChooseUs";
import ProductsShowcase from "../components/modules/ProductsShowcase";
import CraftProcess from "../components/modules/CraftProcess";
import HowToCook from "../components/modules/HowToCook";
import VideoBlock from "../components/modules/VideoBlock";
import WhereToBuy from "../components/modules/WhereToBuy";
import Testimonials from "../components/modules/Testimonials";
import FaqPreview from "../components/modules/FaqPreview";
import ContactStrip from "../components/modules/ContactStrip";

const objSeo = {
  title: "Bit Byte Foods — Soft Idlis, Crispy Dosas, Ready in Minutes",
  keywords:
    "Bit Byte Foods, idly dosa batter, ready to cook batter, no preservatives, all-natural, ragi batter, multi-grain batter, Bagalkot, Vijayapura, Karnataka",
  pathSlug: "/",
  baseUrl: "https://bitbytefoods.com/",
  description:
    "All-natural, preservative-free idly and dosa batter — stone-ground the traditional way, ready to cook. Available at retailers in Bagalkot and Vijayapura, and on Blinkit in Vijayapura, Raichur, Dharwad and Belgaum.",
};

const Home = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <Hero />
      <WhyChooseUs />
      <ProductsShowcase />
      <CraftProcess />
      <HowToCook />
      <VideoBlock />
      <WhereToBuy />
      <Testimonials />
      <FaqPreview />
      <ContactStrip />
    </div>
  );
};

export default Home;
